import { paramCase, capitalCase } from 'change-case';
import { useParams, useLocation } from 'react-router-dom';
// @mui
import { Container } from '@mui/material';
// routes

// sections

import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import useLocales from 'src/hooks/useLocales';
import useSettings from 'src/hooks/useSettings';
import { PATH_DASHBOARD } from 'src/routes/paths';
import Page from 'src/components/Page';
import IncomeCategoryNewEditForm from './IncomeCategoryNewEditForm';
// ----------------------------------------------------------------------

export default function IncomeCategoryCreate() {
  const { themeStretch } = useSettings();

  const { pathname } = useLocation();
  const { translate } = useLocales();
  const { name = '' } = useParams();

  const isEdit = pathname.includes('edit');

  return (
    <Page
      title={
        !isEdit
          ? `${translate('IncomeCategory.CreateIncomeCategory')}`
          : `${translate('IncomeCategory.UpdateIncomeCategory')}`
      }
    >
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={
            !isEdit
              ? `${translate('IncomeCategory.CreateIncomeCategory')}`
              : `${translate('IncomeCategory.EditIncomeCategory')}`
          }
          links={[
            { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },
            {
              name: `${translate('IncomeCategory.IncomeCategoryList')}`,
              href: PATH_DASHBOARD.IncomeCategory.list,
            },
            {
              name: !isEdit
                ? `${translate('IncomeCategory.New')}`
                : `${translate('IncomeCategory.Update')}`,
            },
          ]}
        />
        <IncomeCategoryNewEditForm />
      </Container>
    </Page>
  );
}
